import { User } from 'lib-shared-types-api';
import { DeepWritable } from 'ts-essentials';

import { usersApi } from 'apis/users';
import { api } from 'app/app.api';

import {
  DismissContactMemoryArg,
  MergeContactsApiArg,
  MergeContactsApiResponse,
  ReadContactMemoriesArg,
  ReadContactMemoriesResponse,
} from './types/contactsApi.types';

export const contactsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    mergeContacts: builder.mutation<
      MergeContactsApiResponse,
      MergeContactsApiArg
    >({
      query: ({ target, sources, strategy, dryRun }) => ({
        version: 1,
        method: 'POST',
        path: `contacts/merge`,
        params: {
          dryRun,
        },
        body: { target, sources, strategy },
      }),
      async onQueryStarted({ dryRun }, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { data: contact },
          } = await queryFulfilled;

          if (!dryRun) {
            dispatch(
              usersApi.util.updateQueryData(
                'readUser',
                { id: contact.id },
                (draft) => {
                  const mutableUser = draft.data as DeepWritable<User>;

                  for (const [key, value] of Object.entries(contact)) {
                    mutableUser[key] = value;
                  }
                },
              ),
            );
          }
        } catch {
          /* do nothing */
        }
      },
    }),

    readContactMemories: builder.query<
      ReadContactMemoriesResponse,
      ReadContactMemoriesArg
    >({
      query: ({ contactId, limit }) => ({
        version: 1,
        path: `contacts/${contactId}/memories`,
        params: { limit },
      }),
    }),

    dismissContactMemory: builder.mutation<void, DismissContactMemoryArg>({
      query: ({ contactId, memoryId }) => ({
        version: 1,
        method: 'POST',
        path: `contacts/${contactId}/memories/${memoryId}/dismiss`,
      }),
      async onQueryStarted(
        { contactId, memoryId },
        { dispatch, queryFulfilled },
      ) {
        const patchResult = dispatch(
          contactsApi.util.updateQueryData(
            'readContactMemories',
            { contactId, limit: 10 },
            (draft) => {
              return draft.filter((memory) => memory.id !== memoryId);
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});
